import './cheeus.css';
import 'bootstrap/dist/css/bootstrap.min.css'; // 부트스트랩 CSS 임포트
import thumbnail from './cheeusimg/001.png';
import summary1 from './cheeusimg/002.png';
import summary2 from './cheeusimg/003.png';
import mainpage from './cheeusimg/004.png';
import loginpage from './cheeusimg/005.png';
import loginpagegoogle from './cheeusimg/006.png';
import registerpage from './cheeusimg/007.png';
import registerpagesms from './cheeusimg/008.png';
import myinfo from './cheeusimg/009.png';
import addpost from './cheeusimg/010.png';
import magazinepage from './cheeusimg/011.png';
import adminpage from './cheeusimg/012.png';
import { Carousel } from 'react-bootstrap'; // react-bootstrap에서 Carousel 컴포넌트 가져오기

function Cheeus() {
  const images = [thumbnail, summary1, summary2, mainpage,
    loginpage, loginpagegoogle, registerpage, registerpagesms, myinfo, addpost,
    magazinepage, adminpage
  ];

  return (
    <div className="mydiary">
      <div className="mydiary-container">
        {/* 자동 슬라이드 비활성화 */}
        <Carousel interval={null} data-bs-theme="dark">
          {images.map((image, index) => (
            <Carousel.Item key={index}>
              <img className="d-block" src={image} alt={`Project ${index}`} />
            </Carousel.Item>
          ))}
          <Carousel.Item>
            <iframe className="cheeus-link" src="https://www.youtube.com/embed/VHh2DHvB9l8?si=MXIX2Cs_GGg7zp55" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </Carousel.Item>
          <Carousel.Item>
            <iframe className="cheeus-link" src="https://www.youtube.com/embed/xdaZuTFELiU?si=s0rW4-aazWmrBaUy" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
}

export default Cheeus;
